function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "24 / symbols / linkedin"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.33317 3.75H36.6665C38.6915 3.75 40.3332 5.42893 40.3332 7.5V37.5C40.3332 39.5711 38.6915 41.25 36.6665 41.25H7.33317C5.30813 41.25 3.6665 39.5711 3.6665 37.5V7.5C3.6665 5.42893 5.30813 3.75 7.33317 3.75ZM7.33317 7.49997V37.5H36.6665V7.49997H7.33317ZM23.8332 16.875C22.884 16.875 21.8811 17.1718 20.9954 17.7228L20.1665 16.875H18.3332V30H21.9998V22.5C21.9998 21.4205 23.0888 20.625 23.8332 20.625H25.6665C26.4109 20.625 27.4998 21.4205 27.4998 22.5V30H31.1665V22.5C31.1665 19.026 28.2221 16.875 25.6665 16.875H23.8332ZM14.6665 15C15.679 15 16.4998 14.1606 16.4998 13.125C16.4998 12.0895 15.679 11.25 14.6665 11.25C13.654 11.25 12.8332 12.0895 12.8332 13.125C12.8332 14.1606 13.654 15 14.6665 15ZM12.8332 16.875V30H16.4998V16.875H12.8332Z",
  fill: "white"
}));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.48f944ec.svg";
export { ForwardRef as ReactComponent };